import { Maybe, Mint, EditionMetadata } from '../graphql/indexer-graphql-types'
import { VideoFullData } from '../interfaces'

const getMarketplaceDataFromMintAndeditionMetadata = (
  mint: Maybe<Mint> | undefined,
  editionMetadata: Maybe<EditionMetadata> | undefined
): Omit<VideoFullData, 'video'> => {
  const metadataObject = editionMetadata?.metadataObject
  const minPrice = mint?.floorPriceObject?.floor

  const { sum } = metadataObject?.purchaseReceiptsAggregate?.aggregate || {}
  const sumPrice = sum?.price

  const drop_time = mint?.dropTime?.dropTime ? new Date(mint.dropTime.dropTime) : undefined

  const supply = mint?.milestones?.nextMilestone
    ? mint.milestones.endTime && new Date() >= new Date(mint.milestones.endTime)
      ? mint.supply
      : mint.milestones.nextMilestone
    : editionMetadata?.maxSupply

  return {
    primaryInfo: {
      sold: mint?.supply || 0,
      supply: supply || 0,
      price: editionMetadata?.primarySalePrice || 0,
    },
    secondaryInfo: {
      floor_price: minPrice || 0,
      highest_bid: 0,
      volume: sumPrice || 0,
      items: editionMetadata?.maxSupply || 0,
      owners: 0,
      sales: 0,
    },
    scheduled_time: drop_time,
  }
}

export const getMarketplaceData = (mint: Mint): Omit<VideoFullData, 'video'> => {
  const editionMetadata = mint.editionMetadata
  return getMarketplaceDataFromMintAndeditionMetadata(mint, editionMetadata)
}

export const getMarketplaceDataForCreated = (
  editionMetadata: EditionMetadata
): Omit<VideoFullData, 'video'> => {
  const mint = editionMetadata?.mintObject
  return getMarketplaceDataFromMintAndeditionMetadata(mint, editionMetadata)
}
